import { render } from "./Terms.vue?vue&type=template&id=442c5295&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=442c5295&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442c5295"]])

export default __exports__